import QR_CodeReducer from './qrCodeReducer';

const QR_CODE_REDUCER = {
  QR_CodeReducer,
};
export default QR_CODE_REDUCER;
